/* index.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
var _24 = "._d0altlke:hover{cursor:pointer}";
var _23 = "._irr34135:hover{background-color:rgba(203,166,247,.8)}";
var _22 = "._ouxl1qre{background-position:50% 50%}";
var _21 = "._12veglyw{background-repeat:none}";
var _20 = "._1lrwmp9v{background-size:20px 20px}";
var _19 = "._11q71d4i{background:var(--_1rzmv8e) url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAQAAAACNCElAAAAxklEQVRIx+2Vuw3DMAxEXWUD9VrKvTYJRzAygWpPkSVcBlDtJS6Fg8AQqQ+lAEECXU08iid+pmnoTwWDKzbU6IEbLnkYQaMlD9uA6iqAUArQwDBgX4T1Z+uF4Q4PB/sZmH/1e1BCRZiLhqgWKsJsYjJLUPkDEJKjvmPWwnwCtcKoW4O5VnpTFmaVb8o3LXONOiZAcI3aYe5UIFXiUmv77doOc7oUpDoozLU5iiPFqYtcW4W01LJP3FEiwzXBLG9SUBNq6Ef0BJ8IApq+rItIAAAAAElFTkSuQmCC\")}";
var _18 = "._2rko1l7b{border-radius:3px}";
var _17 = "._19itglyw{border:none}";
var _16 = "._4t3i1tcg{height:24px}";
var _15 = "._1bsb1tcg{width:24px}";
var _14 = "._154ismyl{top:-28px}";
var _13 = "._1xi21y44{right:4px}";
var _12 = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { useSetAtom } from "jotai";
import theme from "../../theme";
import { useNodePicker } from "../../state/node-picker";
import { devToolTabIndexAtom } from "../../state/global";
var _11 = "._4t3imry4{height:var(--_roksyz)}";
var _10 = "._1bsb9tg7{width:var(--_1ea5ebz)}";
var _9 = "._1e0c1ss5{display:var(--_1oddjb5)}";
var _8 = "._t9ecwcso{transform:translateX(var(--_1e5hqsa)) translateY(var(--_jp4btk))}";
var _7 = "._80omtlke{cursor:pointer}";
var _6 = "._1pbyhac1{z-index:99999}";
var _5 = "._bfhk1ghd{background-color:rgba(0,0,255,.3)}";
var _4 = "._1ltvidpf{left:0}";
var _3 = "._154iidpf{top:0}";
var _2 = "._lcxvglyw{pointer-events:none}";
var _ = "._kqswstnw{position:absolute}";
var icon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAQAAAACNCElAAAAxklEQVRIx+2Vuw3DMAxEXWUD9VrKvTYJRzAygWpPkSVcBlDtJS6Fg8AQqQ+lAEECXU08iid+pmnoTwWDKzbU6IEbLnkYQaMlD9uA6iqAUArQwDBgX4T1Z+uF4Q4PB/sZmH/1e1BCRZiLhqgWKsJsYjJLUPkDEJKjvmPWwnwCtcKoW4O5VnpTFmaVb8o3LXONOiZAcI3aYe5UIFXiUmv77doOc7oUpDoozLU5iiPFqYtcW4W01LJP3FEiwzXBLG9SUBNq6Ef0BJ8IApq+rItIAAAAAElFTkSuQmCC";
var NodePickerHighlight = function NodePickerHighlight(_ref) {
  var visible = _ref.visible,
    width = _ref.width,
    height = _ref.height,
    left = _ref.left,
    top = _ref.top;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _lcxvglyw _154iidpf _1ltvidpf _bfhk1ghd _1pbyhac1 _80omtlke _t9ecwcso _1e0c1ss5 _1bsb9tg7 _4t3imry4"]),
    style: {
      "--_1e5hqsa": ix(left, "px"),
      "--_jp4btk": ix(top, "px"),
      "--_1oddjb5": ix(visible ? "block" : "none"),
      "--_1ea5ebz": ix(width, "px"),
      "--_roksyz": ix(height, "px")
    }
  }));
};
function NodePicker() {
  var setTabIndex = useSetAtom(devToolTabIndexAtom);
  var _useNodePicker = useNodePicker(),
    _useNodePicker2 = _slicedToArray(_useNodePicker, 2),
    nodePicker = _useNodePicker2[0],
    nodePickerApi = _useNodePicker2[1];
  var handleMouseMove = React.useCallback(function (e) {
    nodePickerApi.updatePosition(e.target);
  }, [nodePickerApi]);
  var handleNodeClick = React.useCallback(function (e) {
    e.preventDefault();
    nodePickerApi.select(e.target);
    setTabIndex("state");
  }, [nodePickerApi]);
  React.useEffect(function () {
    var active = nodePicker.active;
    if (!active) return;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("click", handleNodeClick);
    document.addEventListener("keydown", nodePickerApi.deactivate);
    return function () {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("click", handleNodeClick);
      document.removeEventListener("keydown", nodePickerApi.deactivate);
    };
  }, [handleMouseMove, handleNodeClick, nodePickerApi, nodePicker.active]);
  return /*#__PURE__*/React.createElement(NodePickerHighlight, {
    top: nodePicker.top,
    left: nodePicker.left,
    visible: Boolean(nodePicker.top && nodePicker.left),
    width: nodePicker.width,
    height: nodePicker.height
  });
}
var NodePickerTrigger = function NodePickerTrigger(_ref2) {
  var children = _ref2.children,
    isActive = _ref2.isActive,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_12, _, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24]), /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: ax(["_r06hglyw _kqswstnw _1xi21y44 _154ismyl _1bsb1tcg _4t3i1tcg _19itglyw _2rko1l7b _11q71d4i _1lrwmp9v _12veglyw _ouxl1qre _irr34135 _d0altlke"]),
    style: {
      "--_1rzmv8e": ix(isActive ? theme.main : theme.main60)
    }
  }, children));
};
export { NodePicker, NodePickerTrigger };